import { axiosUser } from './axiosInstance';

/**
 * Kuicko reward earned by an LK booking (LK ⇄ Kuicko partner rewards).
 * Backend: lk-mobile-backend app/controllers/user/partner_rewards_controller.ts
 *
 * Response `data`:
 *   { state: 'none' | 'pending' | 'ready' | 'redeemed' | 'expired',
 *     title, description, discountType, value, minOrder, expiresAt,
 *     revealed, code (only after reveal), links: { web, android } }
 */
export const getBookingPartnerReward = async (bookingId) => {
  const response = await axiosUser.get(`/user/bookings/${encodeURIComponent(bookingId)}/partner-reward`);
  return response.data?.data ?? { state: 'none' };
};

/** Marks the scratch card revealed and returns the reward with its code. Idempotent. */
export const revealBookingPartnerReward = async (bookingId) => {
  const response = await axiosUser.post(
    `/user/bookings/${encodeURIComponent(bookingId)}/partner-reward/reveal`
  );
  return response.data?.data;
};
